<!-- 项目文件 -->
<template>
    <div class="posre">
                <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>

        <div class="w100p ">
            <div class="w1200 mauto pt50 pb50 overflow textc ">
                <div class="disinblock">
                    <p class="fs26 c333"> 您的分数为 <span class="c1f8">{{fenshu}}</span> 分</p>
                    <img v-if="fenshu<90" class="w100p hauto" :src="shashou" alt="">
                    <img v-else class="w100p hauto" :src="jige" alt="">
                </div>
                <div class="mt20 mb20">
                    <span @click="againMark1()" class="cursor fs20 bradius8 bg1f8 cfff pl10 pr10 pt5 pb5 ml20">
                        重做一遍
                    </span>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                jige: require('../../public/img/cheshen.png'),
                shashou: require('../../public/img/shashou.png'),
                fenshu: '',
                kemuType: ''
            };
        },
        components: {
            Header,
            Footer,
        },
        methods: {
            tiku() {
                let fenshu = this.$route.query.fenshu;
                let kemuType = this.$route.query.kemu;
                this.fenshu = fenshu;
                this.kemuType = kemuType;
            },
            againMark1() {
                if (this.kemuType == 1) {
                    this.$router.push({
                        path: "/Moni1",
                    });
                    // window.open(moni1.href, '_blank');
                }
                if (this.kemuType == 4) {
                    this.$router.push({
                        path: "/Moni4",
                    });
                    //  window.open(moni4.href, '_blank');
                }
            }
        },
        created() {
            this.tiku();
            this.cityName = this.$store.state.cityName;
        },
        mounted() {

        },
    }
</script>
<style scoped>
    .bg777 {
        background: #7ed5f5;
    }
</style>